import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_UserGroupType_Search_Fields: {[id:string]: ISearchProviderField } =
    {
        WB_USRGRPM_ID: {
            type: SearchProviderFieldType.number,
            renderOptions: {
                columnName: 'User Group Type WB Id',
                columnResourceName: 'colUsrGrpTypeWBId',
                alignment: HorizAlignment.Center},
            domainOptions: { }},
        USRGRPM_ID: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'User Group Type Id',
                columnResourceName: 'colUsrGrpTypeId',
                alignment: HorizAlignment.Left},
            domainOptions: { maxLength: 50}},
        USRGRPM_NAME: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'User Group Type Name',
                columnResourceName: 'colUsrGrpTypeName',
                alignment: HorizAlignment.Left},
            domainOptions: { maxLength: 256}},
        MDSET_NAME: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Master Data Set',
                columnResourceName: 'colCustomerTypeMDSet',
                alignment: HorizAlignment.Left },
            domainOptions: { maxLength: 256 }
        },
        CREATED_BY_USER: {
            type: SearchProviderFieldType.string,
            renderOptions: {
                columnName: 'Created By',
                columnResourceName: 'colCreatedBy',
                alignment: HorizAlignment.Left},
            domainOptions: {maxLength: 256}},
        CREATED_DTTS: {
            type: SearchProviderFieldType.saptimestamp,
            renderOptions: {
                columnName: 'Created Date',
                columnResourceName: 'colCreateDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM/dd/yyyy"
            },
            domainOptions: {}
        },
        MODIFIED_DTTS: {
            type: SearchProviderFieldType.saptimestamp,
            renderOptions: {
                columnName: 'Created Date',
                columnResourceName: 'colCreateDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM/dd/yyyy"
            },
            domainOptions: {}
        }
    }

const UserGroupTypeSearchProviderBasic: ISearchProvider =
    {
        keyFields: {id:    'WB_USRGRPM_ID',
            id_ui: 'USRGRPM_ID',
            name:  'USRGRPM_NAME'},


        searchProviderFields: vUI_UserGroupType_Search_Fields,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_UserGroupType_Search',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }

const UserGroupTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UserGroupTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'User Group Type Id',       searchProviderFieldId: 'USRGRPM_ID',    renderOptions: { }},
        {profileFilterName: 'User Group Type Name',     searchProviderFieldId: 'USRGRPM_NAME',  renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'USRGRPM_ID','USRGRPM_NAME','MDSET_NAME', 'CREATED_BY_USER', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: UserGroupTypeSearchProviderBasic,

    profileSortIdDefault: "",
    profileSorts: []
}

const UserGroupTypeSearch: ISearch = {
    searchName: "Find User Group Type",
    renderOptions: { ui5ResourceId: "UserGroupTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UserGroupTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("UserGroupTypeBO", "UserGroupType", UserGroupTypeSearch, "User Group Type Search")

export {UserGroupTypeSearch}